import { composeRecurrenceId } from '@/server-data'

export function isAlreadyExistingRecurrence(
  recurrenceMap: Record<uui.domain.rm.RecurrenceTypes, uui.domain.rm.Recurrence[]>,
  recurrence: uui.domain.rm.Recurrence,
) {
  if (!recurrence || !recurrenceMap) return false
  return (
    recurrenceMap[recurrence.type]?.some(
      r =>
        composeRecurrenceId(r.type, r.value) ===
        composeRecurrenceId(recurrence.type, recurrence.value),
    ) || false
  )
}
